import { render, staticRenderFns } from "./addtypes.vue?vue&type=template&id=f72114c8&"
import script from "./addtypes.vue?vue&type=script&lang=js&"
export * from "./addtypes.vue?vue&type=script&lang=js&"
import style0 from "./addtypes.vue?vue&type=style&index=0&id=f72114c8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports